<template>
  <div class="tabs is-hidden-desktop is-hidden-tablet-only">
    <ul>
      <router-link to="/my-applications" tag="li">
        <a>
          {{ $t('navbar.my_apps') }}
        </a>
      </router-link>
      <router-link to="/authfactors" tag="li">
        <a>
         {{ $t('navbar.auth_factors') }}
        </a>
      </router-link>
      <router-link to="/profile" tag="li">
        <a>
         {{ $t('navbar.profile') }}
        </a>
      </router-link>          
       
      <router-link to="/sessions" tag="li">
        <a>
          {{ $t('navbar.active_sessions') }}
        </a>
      </router-link>
      <router-link to="/settings" tag="li">
        <a>
          {{ $t('navbar.settings') }}
        </a>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  name: "MobileNavbar"
};
</script>

<style scoped>
.tabs li.is-active a {
  color: #3273dc;
  border-bottom: 3px solid #3273dc;
}
</style>
